import RelatedContentGalleryUI, {
  Props as UIProps,
} from '@interflora/ui-components/build/components/RelatedContentGallery/RelatedContentGallery'
import React from 'react'
import { useAnalytics } from 'hooks/useAnalytics'
import { useLoaded } from '@interflora/ui-components/build/components/MainContent/useComponentLoading'

type Props = UIProps

const RelatedContentGallery = (props: Props) => {
  const analytics = useAnalytics()

  const sendRelatedContentGalleryAnalytics = (linkText: string) => {
    analytics.sendRelatedContentGalleryAnalytics(linkText)
  }
  useLoaded(props)

  return <RelatedContentGalleryUI {...props} sendRelatedContentGalleryAnalytics={sendRelatedContentGalleryAnalytics} />
}

export default RelatedContentGallery
